module.exports = __webpack_public_path__ + "img/FLDC.9ddcf103.svg";